// https://overreacted.io/making-setinterval-declarative-with-react-hooks/

import { useEffect, useRef } from 'react';

export default function useInterval(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>(undefined);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      let callbackFunc: () => void = savedCallback.current as () => void;
      if (!callbackFunc) {
        callbackFunc = () => {
          /* do nothing */
        };
      }
      callbackFunc();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    return () => {
      /* do nothing */
    };
  }, [delay]);
}
